var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 133,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.488 55.295v73.124a3.642 3.642 0 01-3.635 3.635H7.17a3.643 3.643 0 01-3.635-3.635V55.295A3.637 3.637 0 017.17 51.66h78.683a3.637 3.637 0 013.635 3.635z",
    fill: "#AAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.244 132H40.756a3.857 3.857 0 01-2.634-.983A3.361 3.361 0 0137 128.584V55.416a3.36 3.36 0 011.122-2.433A3.857 3.857 0 0140.756 52h11.488c.983-.01 1.93.343 2.634.983A3.36 3.36 0 0156 55.416v73.168a3.361 3.361 0 01-1.122 2.433 3.857 3.857 0 01-2.634.983zM59.87 11.072c2.477 7.14-4.81 16.151-4.81 16.151s-11.299-2.566-13.775-9.707c-2.475-7.14 4.81-16.15 4.81-16.15s11.3 2.566 13.776 9.706z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.346 32.623c-7.133 2.498-16.166-4.76-16.166-4.76s2.53-11.307 9.663-13.806c7.133-2.498 16.166 4.76 16.166 4.76s-2.53 11.308-9.663 13.806z",
    fill: "#404040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.086 67.783a3.63 3.63 0 01-3.232-.213L4.101 19.33a3.635 3.635 0 01-1.31-4.971l5.384-9.236a3.634 3.634 0 014.97-1.31L95.9 52.054a3.635 3.635 0 011.31 4.97l-5.385 9.237a3.616 3.616 0 01-1.74 1.522z",
    fill: "#AAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.898 21.924l-9.689 16.627 15.888 9.258 9.688-16.627-15.887-9.258z",
    fill: "#404040"
  })));
}
export default __webpack_public_path__ + "static/media/rewards_placeholder.772962b7.svg";
export { SvgRewardsPlaceholder as ReactComponent };